module.exports = __webpack_public_path__ + "static/media/curves.3a55e263.jpg";